require("core-js/modules/es6.object.define-property");

(function (global, factory) {
  if ('function' == typeof define && define.amd) define(['exports'], factory);else if ('undefined' != typeof exports) factory(exports);else {
    var mod = {
      exports: {}
    };
    factory(mod.exports), global.example = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: !0
  }), exports["default"] = function (usage, description) {
    if ('string' != typeof usage || 'string' != typeof description) throw new TypeError('Usage for adding an Example: args.example("usage", "description")');
    return this.details.examples.push({
      usage: usage,
      description: description
    }), this;
  };
});